export const getInitialValues = ({ header, bestTitle, worthTitle, state }) => ({
    initialScaleValue: header || state?.scaleValue || 'یک عنوان وارد کنید',
    initialSubHeader: state?.subScaleValue || '',
    initialBestValue: bestTitle || state?.bestValue || 'بهترین',
    initialWorthValue: worthTitle || state?.worthValue || 'بدترین',
    initialRating: state?.mainActive || 0,
  });
  
  export const handleActiveColor = (id, theme) => {
    switch (id) {
      case 1: return '#C70039';
      case 2: return '#FF6969';
      case 3: return theme.palette.yellow[600];
      case 4: return '#65B741';
      case 5: return '#508D69';
      default: return '';
    }
  };
  
  export const isPublishReadOnly = (currentPage, readOnly, finalSelectValues, drawerData) => {
    if (!currentPage.startsWith('/publish')) return false;
    const titleIndex = finalSelectValues.findIndex(item => item.name === 'FieldCondition');
    const title = finalSelectValues[titleIndex]?.value;
    const idx = drawerData.findIndex(item => item.title === title);
    return readOnly || drawerData[idx]?.state?.readOnly;
  };
  
  export const fillInputValue = (drawerData, index, values) => {
    if (!drawerData[index]) return;
    const state = drawerData[index].state;
    Object.assign(state, {
      scaleValue: values.scaleValue,
      subScaleValue: '',
      bestValue: values.bestValue,
      worthValue: values.worthValue,
      mainActive: values.active,
      readOnly: values.readOnly,
    });
  };
  